import { createFileRoute } from '@tanstack/react-router';
import { TasksSettingsPage } from '@/components/TasksSettingsPage';

export const Route = createFileRoute('/_authenticated/settings/tasks/')({
  component: TasksSettingsPage,
});
